import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import Input from "../../components/UI/Input/Input";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Spinner from "../../components/UI/Spinner/Spinner";
import * as actions from "../../store/actions/index";
import { updateObject, checkValidity } from "../../shared/utility";
import "./Auth.css";
import $ from "jquery";
const timestamp = new Date().getTime();
const logoIcon = require("../../styles/images/Al-Raihann-logo.webp");
// let path = "https://fayzetaheri.com/images";
let path = "";
fetch("./newpath.json?v=" + timestamp)
  .then(function (res) {
    return res.json();
  })
  .then(function (data) {
    // store Data in State Data Variable
    path = data.prod;
  })
  .catch(function (err) {
    console.log(err, " error");
  });
class Auth extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tncpolicy: false,
    };
  }
  componentDidMount() {}
  closeModal = (name) => {
    this.setState({ [`${name}`]: false });
  };
  render() {
    return (
      <div className="loginPage d-flex flex-column justify-content-center align-items-center">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-8 col-10">
              <div className="wrapper">
                <div className="logoImage ">
                  <div className="d-flex justify-content-center">
                    <img
                      className="align-self-center mr-2"
                      src={logoIcon}
                      alt=""
                      style={{ height: "auto", width: "15rem" }}
                    />
                  </div>
                </div>
                <div className="text-center">
                  <p>Welcome to Al raihaan</p>
                </div>
                <div className="text-center loginbtn">
                  <Button
                    variant="primary"
                    className=""
                    onClick={() => this.setState({ tncpolicy: true })}
                  >
                    Login with ITS
                    {/* <p>{items.receiptid}</p> */}
                  </Button>
                  {/* <a
                      href="https://www.its52.com/Login.aspx?OneLogin=FZTHRIHAN"
                      className="btn btn-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Login with ITS
                    </a> */}
                </div>
                <div className="version">
                  {" "}
                  Legal entity - FAYZ E TAHERI PRIVATE LIMITED
                </div>
                {/* <div className="version">Version - {global.appVersion}</div> */}
              </div>
            </div>
          </div>
        </div>
        <>
          <div className="footnote d-flex justify-content-center mt-4 text-center p-4 small text-light">
            Copyright @2025 FAYZ E TAHERI PRIVATE LIMITED All Rights Reserved.
            {/* Version - {global.appVersion} */}
            {/* <span>Version - {global.appVersion}</span> */}
          </div>
        </>
        <Modal
          show={this.state.tncpolicy}
          onHide={() => this.closeModal("tncpolicy")}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          scrollable
          centered
          className="policymodal"
          data-lenis-prevent="true"
          // style={{height:"90%"}}
          // onShow={this.stopScroll}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Terms & Conditions
            </Modal.Title>
          </Modal.Header>
          <Modal.Footer style={{ alignSelf: "center" }}>
            <Button
              variant="outline-primary"
              onClick={() => this.closeModal("tncpolicy")}
            >
              I Disagree
            </Button>
            <a
              //href="https://www.its52.com/Login.aspx?OneLogin=FZTHRIHAN"
              href="#/home"
              className="btn btn-primary"
              // target="_blank"
              rel="noopener noreferrer"
            >
              I Agree
            </a>
          </Modal.Footer>
          <Modal.Body>
            {/* <Form.Control as="textarea" value={this.state.testimony} /> */}

            <iframe
              style={{ width: "100%", height: "99%" }}
              src={`${path}/${"policy"}/${"alraihaan card.pdf"}?v=${timestamp}`}
            ></iframe>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default Auth;
